import React from 'react'
import PageHeader from '../components/Header'
import HeaderImage from '../components/HeaderImage'
import NaborFormular from '../components/NaborFormular'
import PageFooter from '../components/Footer'

const PublicApplication = () => (
  <div>
    <PageHeader />
    <HeaderImage
      maintitle="Online prihláška"
      subtitle="začnite svoju 10-dňovú skúšobnú dobu ešte dnes"
      img="images/general-bg-kids.jpg"
    />
    <NaborFormular
      eventNames={['bullyProof', 'Gracie Combatives', 'Women Empowered', 'Mastercycle']}
    />
    <PageFooter />
  </div>
)

export default PublicApplication
